import { A, useNavigate } from "@solidjs/router";
import { LogOut } from "lucide-solid";
import { type ParentComponent, Show } from "solid-js";
import { getClaims, isAdmin, isAuthenticated, setToken } from "../lib/auth";
import { AgentUiProvider } from "../lib/solid-agent-ui";
import { ChatWidget } from "./chat/ChatWidget";
import { ChatWidgetBroker } from "./chat-broker/ChatWidget";
import { Button } from "./ui/button";

const NavLink: ParentComponent<{ href: string }> = (props) => (
  <A
    href={props.href}
    class="text-sm text-muted-foreground hover:text-foreground transition-colors"
    activeClass="text-foreground font-medium"
    end
  >
    {props.children}
  </A>
);

const Layout: ParentComponent = (props) => {
  const navigate = useNavigate();
  const logout = () => {
    setToken(null);
    navigate("/login");
  };
  return (
    <AgentUiProvider>
      <div class="min-h-screen flex flex-col bg-background">
        <header class="border-b bg-card">
          <nav class="container flex items-center gap-6 h-14">
            <A href="/" class="font-bold text-lg tracking-tight">Booking Control</A>
            <Show when={isAuthenticated()}>
              <NavLink href="/items">Items</NavLink>
              <NavLink href="/me/tickets">My tickets</NavLink>
              <Show when={isAdmin()}>
                <span class="text-muted-foreground/50">·</span>
                <NavLink href="/admin/items">Admin items</NavLink>
                <NavLink href="/admin/groups">Groups</NavLink>
                <NavLink href="/admin/clients">Clients</NavLink>
                <NavLink href="/admin/tickets">Tickets</NavLink>
                <NavLink href="/admin/rules">Rules</NavLink>
                <NavLink href="/admin/ai">AI</NavLink>
              </Show>
            </Show>
            <div class="ml-auto flex items-center gap-3">
              <Show
                when={isAuthenticated()}
                fallback={<A href="/login" class="text-primary text-sm">Login</A>}
              >
                <span class="text-sm text-muted-foreground">
                  {getClaims()?.name ?? getClaims()?.sub} ·{" "}
                  <span class="font-medium text-foreground">{getClaims()?.role}</span>
                </span>
                <Button variant="ghost" size="sm" onClick={logout}>
                  <LogOut class="h-4 w-4" />
                  Logout
                </Button>
              </Show>
            </div>
          </nav>
        </header>
        <main class="container py-8 flex-1">{props.children}</main>
        {/* A/B test: 2 chat widgets song song.
            A (purple, bottom-right) = embedded approach (booking-ai-worker).
            B (blue,   bottom-left)  = broker approach (ai-agent-gateway). */}
        <ChatWidget />
        <ChatWidgetBroker />
      </div>
    </AgentUiProvider>
  );
};

export default Layout;
